import { Component } from '@angular/core';
import { AGENT_PERMISSIONS } from 'src/app/ai-agents/models/ai-agents.models';
import { AgentPermissionsService } from 'src/app/ai-agents/services/agent-permissions.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent {
  readonly P = AGENT_PERMISSIONS;

  constructor(public perms: AgentPermissionsService) { }

  get showAgentsGroup(): boolean {
    return this.perms.hasAny(this.P.agentList, this.P.conversationList, this.P.providerList, this.P.modelList, this.P.capabilityList, this.P.planList);
  }
}
